import { cn } from '../../lib/cn';

export interface ProgressBarProps {
  value: number;
  label?: string;
  className?: string;
  tone?: 'brand' | 'success' | 'muted';
}

const TONES: Record<NonNullable<ProgressBarProps['tone']>, string> = {
  brand: 'bg-brand-gradient',
  success: 'bg-[color:var(--success)]',
  muted: 'bg-stroke',
};

export function ProgressBar({ value, label, className, tone = 'brand' }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));
  return (
    <div className={cn('w-full', className)}>
      {label && (
        <div className="mb-1 flex items-center justify-between text-xs text-text-muted">
          <span>{label}</span>
          <span>{clamped}%</span>
        </div>
      )}
      <div
        className="h-2 w-full overflow-hidden rounded-full bg-bg-soft"
        role="progressbar"
        aria-valuenow={clamped}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={cn('h-full rounded-full transition-all duration-300', TONES[tone])}
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
